import Vue from 'vue'
import Vuex from 'vuex'
import typeQuestions from './modules/typeQuestions'
import questions from './modules/questions'
import properties from './modules/properties'
import perfis from './modules/perfis'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		typeQuestions: {
			state: typeQuestions.state,
			mutations: typeQuestions.mutations,
			actions: typeQuestions.actions,
			getters: typeQuestions.getters
		},
		questions: {
			state: questions.state,
			mutations: questions.mutations,
			actions: questions.actions,
			getters: questions.getters
		},
		properties: {
			state: properties.state,
			mutations: properties.mutations,
			actions: properties.actions,
			getters: properties.getters
		},
		perfis: {
			state: perfis.state,
			mutations: perfis.mutations,
			actions: perfis.actions
		}
	}
})
